import * as Sentry from '@sentry/react';
import { Route, Routes } from 'react-router-dom';
import { RequireAuth } from './routes/RequireAuth';
import { RequireNoAuth } from './routes/RequireNoAuth';
import { RequireCapability } from './routes/RequireCapability';
import { DashboardLayout } from './layout/DashboardLayout';
import { LoginPage } from './pages/LoginPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { AuthCallbackPage } from './pages/AuthCallbackPage';
import { HomePage } from './pages/HomePage';
import { CalendarPage } from './pages/CalendarPage';
import { ChoirPage } from './pages/ChoirPage';
import { ConfigPage } from './pages/ConfigPage';
import { FormsPage } from './pages/FormsPage';
import { MembersPage } from './pages/MembersPage';
import { NewsPage } from './pages/NewsPage';
import { PlaybacksPage } from './pages/PlaybacksPage';
import { PublicFormPage } from './pages/PublicFormPage';
import { PublicSchedulePage } from './pages/PublicSchedulePage';
import { CostumesPage } from './pages/CostumesPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { SentryTestPage } from './pages/SentryTestPage';
import { SENTRY_TEST_ROUTE, sentryTestRouteEnabled } from './lib/sentry';

const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);

export default function App() {
  return (
    <SentryRoutes>
      {sentryTestRouteEnabled() ? (
        <Route path={SENTRY_TEST_ROUTE} element={<SentryTestPage />} />
      ) : null}

      <Route
        path="/login"
        element={
          <RequireNoAuth>
            <LoginPage />
          </RequireNoAuth>
        }
      />

      <Route path="/auth/callback" element={<AuthCallbackPage />} />

      <Route path="/reset-password" element={<ResetPasswordPage />} />

      <Route path="/forms/:slug" element={<PublicFormPage />} />
      <Route path="/ablaufplan/:slug" element={<PublicSchedulePage />} />

      <Route element={<RequireAuth />}>
        <Route element={<DashboardLayout />}>
          <Route index element={<HomePage />} />

          <Route
            path="calendar"
            element={
              <RequireCapability capability="canManageEvents">
                <CalendarPage />
              </RequireCapability>
            }
          />

          <Route
            path="choir"
            element={
              <RequireCapability capability="isAdmin">
                <ChoirPage />
              </RequireCapability>
            }
          />

          <Route
            path="playbacks"
            element={
              <RequireCapability capability="isAdmin">
                <PlaybacksPage />
              </RequireCapability>
            }
          />

          <Route
            path="news"
            element={
              <RequireCapability capability="isAdmin">
                <NewsPage />
              </RequireCapability>
            }
          />

          <Route
            path="costumes"
            element={
              <RequireCapability capability="canManageCostumes">
                <CostumesPage />
              </RequireCapability>
            }
          />

          <Route
            path="config"
            element={
              <RequireCapability capability="isAdmin">
                <ConfigPage />
              </RequireCapability>
            }
          />

          <Route
            path="forms"
            element={
              <RequireCapability capability="isAdmin">
                <FormsPage />
              </RequireCapability>
            }
          />

          <Route
            path="members"
            element={
              <RequireCapability capability="isAdmin">
                <MembersPage />
              </RequireCapability>
            }
          />
        </Route>
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </SentryRoutes>
  );
}
